import { Progress as ProgressPrimitive } from "radix-ui"

import { theme, type ThemeKeys } from "../../theme"
import styles from "./ProgressCircle.module.css"

const thickness = 3.6
const dimensions = 44

export interface ProgressCircleProps {
  color?: ThemeKeys<"color">
}
/**
 * ProgressCircle.
 *
 * The ProgressCircle component displays the progress status for tasks
 * that take a long time.
 *
 * Follow MUI animation.
 * See: https://github.com/mui/material-ui/tree/b4c2e4ecb8dfec0432f9f55778cd90e10c5be5d7/packages/mui-material/src/CircularProgress
 */
export function ProgressCircle({
  color = "currentColor",
}: ProgressCircleProps) {
  return (
    <ProgressPrimitive.Root asChild className={styles.root}>
      <ProgressPrimitive.Indicator asChild>
        <svg
          viewBox={`${dimensions / 2} ${
            dimensions / 2
          } ${dimensions} ${dimensions}`}
        >
          <circle
            cx={dimensions}
            cy={dimensions}
            fill="none"
            r={(dimensions - thickness) / 2}
            strokeDasharray="80px, 200px"
            strokeDashoffset={0}
            strokeWidth={thickness}
            className={styles.circle}
            style={{ stroke: color && theme.color[color] }}
          />
        </svg>
      </ProgressPrimitive.Indicator>
    </ProgressPrimitive.Root>
  )
}
